import { Checkbox } from '../atomic-elements/atoms/checkbox/checkbox'
import { JSONElementFactory } from '../json-elements/higher-order-components/json-element-factory'
import { JSONInputFactory } from '../json-elements/higher-order-components/json-input-factory'
import { CheckboxField } from 'browser/components/atomic-elements/molecules/fields/checkbox-field'

export const UICheckbox = JSONInputFactory(Checkbox)
export const UICheckboxField = JSONElementFactory(CheckboxField)
